import { render, staticRenderFns } from "./CustomerProductsForm.vue?vue&type=template&id=13bfd02f&"
import script from "./CustomerProductsForm.vue?vue&type=script&lang=js&"
export * from "./CustomerProductsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports